module.exports = __webpack_public_path__ + "media/images/common/digicat_icons-89edfb66fb227dbee016dd8404c8c6a0.png";